var map = {
	"./servicio1.png": 8500,
	"./servicio2.png": 959,
	"./servicio21.png": 678,
	"./servicio3.png": 5862,
	"./servicio4.png": 4489,
	"./servicio5.png": 8736,
	"./servicio51.png": 5483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8353;